import type { ClientProposal } from "./proposalTypes";
import { beazleyProposal } from "./data/beazley";
import { jetsProposal } from "./data/jets";
import { aprilProposal } from "./data/april";
import { northProposal } from "./data/north";

const PROPOSALS: Record<string, ClientProposal> = {
  [beazleyProposal.slug]: beazleyProposal,
};

export function getProposal(slug: string): ClientProposal | null {
  return PROPOSALS[slug] ?? null;
}

export function isKnownProposalSlug(slug: string): boolean {
  return slug in PROPOSALS || slug === jetsProposal.slug || slug === aprilProposal.slug || slug === northProposal.slug;
}

export function listProposalSlugs(): string[] {
  return Object.keys(PROPOSALS);
}
